import React, { useState, useEffect } from 'react';
import { createVaga, fetchVagas, fetchStatusAtivos, deleteVaga, updateVaga } from '../api';
import TextField from '@mui/material/TextField';
import SaveIcon from '@mui/icons-material/Save';
import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ReplayIcon from '@mui/icons-material/Replay';
import Button from '@mui/material/Button';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from "@mui/material/Typography";
import Stack from '@mui/material/Stack';
import StatusSelect from './StatusSelect';
import AntSwitch from './AntSwitch'

import Alerts from './Alert';
import AlertDialog from './Dialog';

export default function VagaForm({ user }) {
  const empty = {
    id: undefined,
    titulo: "",
    dados_vaga: "",
    funcao: "",
    cod_vaga: "",
    seguimento: "",
    bairro: "",
    cidade: "",
    beneficios: "",
    responsabilidade: "",
    requisitos: "",
    empresa: "",
    quantidade_vagas: "",
    criado_em: "",
    id_usuario_criador: 0,
    id_status: 1,
    visivel: true,
    motivo_encerramento: ""
  };
  
  const [vaga, setVaga] = useState(empty);
  const [vagas, setVagas] = useState([]);
  const [status, setStatus] = useState([]);
  const [verifyStatus, setVerifyStatus] = useState(false);

  const [openSnack, setOpenSnack] = useState(false);
  const [snackType, setSnackType] = useState("info");
  const [snackMsg, setSnackMsg] = useState("");

  const [openDialog, setOpenDialog] = useState(false);
  const [titleDialog, setTitleDialog] = useState("info");
  const [mensagem, setMensagem] = useState("");
  const [idForDelete, setIdForDelete] = useState(null);

  const [openAccordion, setOpenAccordion] = useState(false);

  const loadVagas = async () => {
    const resp = await fetchVagas();
    setVagas(resp);
  };

  useEffect(() => {
    fetchStatusAtivos().then(data => setStatus(data));
    fetchVagas().then(data => setVagas(data));
  }, []);

  const submit = async e => {
    e.preventDefault();

    let payload = {
      ...vaga,
      cod_vaga: vaga.cod_vaga?.replace(/\s+/g, "") || ""
    };

    const verifyStatus = status.find(s => Number(s.id) === Number(payload.id_status));
    if (verifyStatus?.exige_motivo && (!payload.motivo_encerramento || payload.motivo_encerramento.trim() === "")) {
      setSnackType("warning");
      setSnackMsg("O motivo é obrigatório para o status selecionado.");
      setOpenSnack(true);
      return;
    }

    if (!verifyStatus?.exige_motivo) {
      payload = {
        ...payload,
        motivo_encerramento: null,
        encerrado_em: null
      };
    } else {
      payload.encerrado_em = payload.encerrado_em || new Date();
    }

    const codigoExistente = vagas.find(v => v.cod_vaga.trim() === payload.cod_vaga.trim() && v.id !== payload.id);
    if (codigoExistente) {
      setSnackType("info");
      setSnackMsg("O código da vaga já existe. Por favor, utilize um código diferente.");
      setOpenSnack(true);
      return;
    }

    try {
      if (payload.id > 0) {
        await updateVaga(payload.id, payload);
        setSnackMsg("Vaga atualizada com sucesso!");
      } else {
        await createVaga(payload);
        setSnackMsg("Vaga criada com sucesso!");
      }

      setVaga(empty);
      setSnackType("success");
      setOpenSnack(true);
      await loadVagas();
    } catch (ex) {
      setSnackMsg(ex?.response?.data?.message || ex?.message || "Erro ao processar requisição.");
      setSnackType("error");
      setOpenSnack(true);
    }
  };

  const cancelEdit = () => {
    setOpenAccordion(false);
    setVerifyStatus(false)
    setVaga(empty);
  };

  const confirmDelete = async (id) => {
    await deleteVaga(id);
    loadVagas();
  };

  const handleDelete = async (id) => {
    setOpenDialog(true);
    setTitleDialog("Exclusão");
    setMensagem("Deseja realmente excluir esta vaga?");
    setIdForDelete(id);
  };

  const handleRepost = (vagaEdit) => {
    setVerifyStatus(
      status.find(s => Number(s.id) === Number(vagaEdit.status?.id))?.exige_motivo
    );
    setVaga({
      ...vagaEdit,
      id_status: Number(vagaEdit.status?.id),
      motivo_encerramento: vagaEdit.motivo_encerramento || "",
      id: undefined
    });
    setOpenAccordion(true);
  };

  const handleEdit = (vagaEdit) => {
    setVerifyStatus(
      status.find(s => Number(s.id) === Number(vagaEdit.status?.id))?.exige_motivo
    );
    setVaga({
      ...vagaEdit,
      id_status: Number(vagaEdit.status?.id),
      motivo_encerramento: vagaEdit.motivo_encerramento || ""
    });
    setOpenAccordion(true);
  };

  const handleChangeVisible = () => {
    setVaga({
      ...vaga,
      visivel: !vaga.visivel
    });
  };

  const handleChangeStatus = (id) => {
    setVerifyStatus(
      status.find(s => Number(s.id) === Number(id))?.exige_motivo
    );
    setVaga(prev => ({
      ...prev,
      id_status: Number(id)
    }));
  };

  return (
    <div className="mb-3 p-3">
      <Accordion
        expanded={openAccordion}
        onChange={() => setOpenAccordion(prev => !prev)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <h5 className='reconect-text'>Cadastro de Vaga</h5>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={submit}>
            <div className="row">
              <div className="col-xs-12 col-md-4 mb-2">
                <TextField
                  label="Título"
                  variant="outlined"
                  fullWidth
                  value={vaga.titulo}
                  onChange={ e => setVaga({...vaga,titulo:e.target.value}) }
                  required
                  color="primary"
                  inputProps={{ maxLength: 50 }}
                />
              </div>
              <div className="col-xs-12 col-md-4 mb-2">
                <TextField
                  label="Código da Vaga"
                  variant="outlined"
                  fullWidth
                  value={vaga.cod_vaga}
                  onChange={ e => setVaga({...vaga,cod_vaga:e.target.value}) }
                  required
                  color="primary"
                  inputProps={{ maxLength: 20 }}
                />
              </div>
              <div className="col-xs-12 col-md-4 mb-2">
                <TextField
                  label="Função"
                  variant="outlined"
                  fullWidth
                  value={vaga.funcao}
                  onChange={ e => setVaga({...vaga,funcao:e.target.value}) }
                  required
                  color="primary"
                  inputProps={{ maxLength: 50 }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-md-4 mb-2">
                <TextField
                  label="Seguimento"
                  variant="outlined"
                  fullWidth
                  value={vaga.seguimento}
                  onChange={ e => setVaga({...vaga,seguimento:e.target.value}) }
                  required
                  color="primary"
                  inputProps={{ maxLength: 50 }}
                />
              </div>
              <div className="col-xs-12 col-md-4 mb-2">
                <TextField
                  label="Bairro da Vaga"
                  variant="outlined"
                  fullWidth
                  value={vaga.bairro}
                  onChange={ e => setVaga({...vaga,bairro:e.target.value}) }
                  required
                  color="primary"
                  inputProps={{ maxLength: 50 }}
                />
              </div>
              <div className="col-xs-12 col-md-4 mb-2">
                <TextField
                  label="Cidade da Vaga"
                  variant="outlined"
                  fullWidth
                  value={vaga.cidade}
                  onChange={ e => setVaga({...vaga,cidade:e.target.value}) }
                  required
                  color="primary"
                  inputProps={{ maxLength: 50 }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-md-6 mb-2">
                <TextField className="form-control" label="Dados da Vaga" value={vaga.dados_vaga} multiline rows={8} inputProps={{ maxLength: 2000 }}
                  onChange={e=>setVaga({...vaga,dados_vaga:e.target.value})} required fullWidth color="primary"></TextField>
              </div>
              <div className="col-xs-12 col-md-6 mb-2">
                <TextField className="form-control" label="Benefícios da Vaga" value={vaga.beneficios} multiline rows={8} inputProps={{ maxLength: 500 }}
                  onChange={e=>setVaga({...vaga,beneficios:e.target.value})} required fullWidth color="primary"></TextField>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-md-6 mb-2">
                <TextField className="form-control" label="Responsabilidades e Atribuições" value={vaga.responsabilidade} multiline rows={8}
                  inputProps={{ maxLength: 1000 }} onChange={e=>setVaga({...vaga,responsabilidade:e.target.value})} required fullWidth color="primary"></TextField>
              </div>
              <div className="col-xs-12 col-md-6 mb-2">
                <TextField className="form-control" label="Requisitos e Qualificações" value={vaga.requisitos} multiline rows={8}
                  inputProps={{ maxLength: 2000 }} onChange={e=>setVaga({...vaga,requisitos:e.target.value})} required fullWidth color="primary"></TextField>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-md-6 mb-2">
                <TextField className="form-control" label="Sobre a Empresa" value={vaga.empresa} multiline rows={8} inputProps={{ maxLength: 2000 }}
                  onChange={e=>setVaga({...vaga,empresa:e.target.value})} required fullWidth color="primary"></TextField>
              </div>
              <div className="col-xs-12 col-md-6 mb-2">
                <StatusSelect value={vaga.id_status} onChange={handleChangeStatus} />
                <br />
                <div className="col-12 mb-4">
                  {verifyStatus && (
                    <TextField
                      label="Motivo"
                      variant="outlined"
                      fullWidth
                      value={vaga.motivo_encerramento || ""}
                      onChange={e => setVaga({ ...vaga, motivo_encerramento: e.target.value })}
                      required
                      color="primary"
                      className="mt-3"
                    />
                  )}
                </div>
                <div className="row">
                  <div className="col-xs-12 col-md-6 mb-4">
                    <TextField
                      label="Quantidade de vagas"
                      variant="outlined"
                      fullWidth
                      value={vaga.quantidade_vagas}
                      onChange={e => {
                        if (e.target.value.length <= 4) {
                          setVaga({...vaga, quantidade_vagas: e.target.value});
                        }
                      }}
                      required
                      color="primary"
                      type="number"
                      inputProps={{ inputMode: "numeric", pattern: "[0-9]{0,4}" }}
                    />
                  </div>
                  <div className="col-xs-12 col-md-6 mb-4" style={{ alignContent: "center", justifyItems: "center" }}>
                    <Typography className="reconect-training-title-infos">Esta ativo?</Typography>
                    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                      <Typography>NÃO</Typography>
                      <AntSwitch inputProps={{ 'aria-label': 'ant design' }} checked={vaga.visivel} onChange={handleChangeVisible} />
                      <Typography>SIM</Typography>
                    </Stack>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 mb-4">
              <Button
                size="small"
                type="submit"
                color="success"
                startIcon={<SaveIcon />}
                variant="contained"
                style={{ float: "right", width: "120px" }}
              >
                Salvar
              </Button>
              <Button
                size="small"
                color="error"
                startIcon={<ClearIcon />}
                variant="contained"
                style={{ float: "left", width: "120px" }}
                onClick={() => cancelEdit()}
              >
                Cancelar
              </Button>
            </div>
          </form>
        </AccordionDetails>
      </Accordion>
      
      {/* 🔥 TABELA DAS VAGAS */}

      <h5 className='reconect-text mt-4'>VAGAS CADASTRADAS</h5>

      <TableContainer component={Paper} className="mt-3">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>Código</strong></TableCell>
              <TableCell><strong>Título</strong></TableCell>
              <TableCell><strong>Cidade</strong></TableCell>
              <TableCell><strong>Status</strong></TableCell>
              <TableCell><strong>Ativo?</strong></TableCell>
              <TableCell><strong>Ações</strong></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {(vagas ?? []).map(v => (
              <TableRow key={v.id}>
                <TableCell>{v.cod_vaga}</TableCell>
                <TableCell>{v.titulo}</TableCell>
                <TableCell>{v.cidade}</TableCell>
                <TableCell>{v.status?.descricao}</TableCell>
                <TableCell style={{ color: v.visivel ? "green" : "red" }}>
                  {v.visivel ? "Sim" : "Não"}
                </TableCell>

                <TableCell>
                  <Button
                    size="small"
                    color="primary"
                    startIcon={<EditIcon />}
                    onClick={() => handleEdit(v)}
                    style={{ minWidth: "105px" }}
                  >
                    Editar
                  </Button>

                  <Button
                    size="small"
                    color="secondary"
                    startIcon={<ReplayIcon />}
                    onClick={() => handleRepost(v)}
                    style={{ minWidth: "105px" }}
                  >
                    Repostar
                  </Button>

                  <Button
                    size="small"
                    color="error"
                    startIcon={<DeleteIcon />}
                    onClick={() => handleDelete(v.id)}
                    style={{ minWidth: "105px" }}
                  >
                    Excluir
                  </Button>
                </TableCell>

              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Alerts 
        openSnack={openSnack}
        setWhenOpen={setOpenSnack}
        type={snackType}
        msg={snackMsg}
      />
      <AlertDialog 
        openDialog={openDialog}
        title={titleDialog}
        msg={mensagem}
        showDialog={setOpenDialog}
        confirmCase={() => confirmDelete(idForDelete)}
      />
    </div>
  );
}
